import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInvite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconInvite"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V10.3669L22 9.7183V21H2V9.7183L4 10.3669V2ZM5.5 10.8534L12 12.9615L18.5 10.8534V3.5H5.5V10.8534ZM9 7H15V8.5H9V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInvite;
